import { Grading } from '@mui/icons-material'
import { Box, Button } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FaFileDownload } from 'react-icons/fa'
import { useGET_submissionByIdQuery } from 'redux/api/submissionsApi'

interface IProps {
  id: number,
}


const SubmissionInfo: FC<IProps> = ({ id }) => {
  const { t } = useTranslation()

  const { data: submission } = useGET_submissionByIdQuery(id.toString())

  return (
    <> { 
        submission && 
        <div style={{ marginTop: '20px', fontSize: '14px' }}>

            {submission.description &&
                <div dangerouslySetInnerHTML={{ __html: submission.description }} style={{ 
                  display: 'block',
                }} />
            }  

            {submission.materials && submission.materials.map(material => <div key={material.id} style={{ 
                marginTop: '10px', 
                paddingTop: '10px', 
                borderTop: '1px solid #ccc'
            }}>
                <a href={material.url} target="_blank" rel="noreferrer"><FaFileDownload/> {material.title}</a>
            </div>)}  

        </div>
        }
    </>
  )
}

export default SubmissionInfo
